import { render, staticRenderFns } from "./Article04.vue?vue&type=template&id=4f2a2ffe&"
import script from "./Article04.vue?vue&type=script&lang=js&"
export * from "./Article04.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/renew_info.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/scss/article/article.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports